import React from "react";
import img from "../../Images/pdf-icon.png";
import file from "../../Images/Questions-and-Answers.pdf";
const Samp = () => {
  return (
    <div className="row">
      <div className="col-md-12">
        <a href={file} target="_blank" rel="noreferrer">
          <img src={img} alt="icon" />
          <p>Questions & Answers</p>
        </a>
      </div>
    </div>
  );
};
export default Samp;
